<template>
  <div class="site-menu">
    <div class="site-menu__container">
      <a href="https://alvaroapoio.com.br">
        <img
          src="/static/images/logo-alvaro-interna.svg"
          alt="Laboratório Alvaro"
        >
      </a>

      <nav class="site-menu__navbar">
        <div
          id="site-menu1"
          class="site-menu__collapse"
        >
          <ul class="site-menu__navbar-nav">
            <li class="site-menu__dropdown">
              <div class="site-menu__nav-link">
                Quem Somos
                <svg-loader src="../../../../static/images/site/arrow-down.svg" />
              </div>
              <ul class="site-menu__dropdown-menu">
                <li>
                  <a
                    id="menu-institucional"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/institucional"
                  >
                    Institucional
                  </a>
                </li>
                <li>
                  <a
                    id="menu-diferenciais"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/diferenciais"
                  >
                    Diferenciais Alvaro Apoio
                  </a>
                </li>
                <li>
                  <a
                    id="menu-qualidade-acreditacoes"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/qualidade-acreditacoes"
                  >
                    Qualidade e Acreditações
                  </a>
                </li>
                <li>
                  <a
                    id="menu-nto"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/nto"
                  >
                    Nossos NTOs
                  </a>
                </li>
                <li>
                  <a
                    id="menu-somos-dasa"
                    class="site-menu__dropdown-item"
                    href="https://dasa.com.br/somos-dasa/"
                  >
                    Somos Dasa
                  </a>
                </li>
                <li>
                  <a
                    id="menu-portal-privacidade"
                    class="site-menu__dropdown-item"
                    href="https://dasa.com.br/portal-de-privacidade/"
                  >
                    Portal de Privacidade
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          id="site-menu2"
          class="site-menu__collapse"
        >
          <ul class="site-menu__navbar-nav">
            <li class="site-menu__dropdown">
              <div class="site-menu__nav-link">
                Áreas de Atuação
                <svg-loader src="../../../../static/images/site/arrow-down.svg" />
              </div>
              <ul class="site-menu__dropdown-menu">
                <li>
                  <a
                    id="site-menu2-analises-clinicas"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/analises-clinicas"
                  >
                    Análises Clínicas
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu2-anatomia-patologica"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/anatomia"
                  >
                    Anatomia patológica
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu2-toxicologia"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/toxicologia"
                  >
                    Toxicologia
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu2-genomica"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/genomica"
                  >
                    Genômica
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu2-triagem-neonatal"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/triagem-neonatal"
                  >
                    Triagem Neonatal
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu2-diagnostico-imagem"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/diagnostico-imagem"
                  >
                    Diagnóstico por Imagem
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          id="site-menu3"
          class="site-menu__collapse site-menu__collapse--active"
        >
          <ul class="site-menu__navbar-nav">
            <li class="site-menu__dropdown">
              <div class="site-menu__nav-link site-menu__nav-link--active">
                Exames
                <svg-loader src="../../../../static/images/site/arrow-down.svg" />
              </div>
              <ul class="site-menu__dropdown-menu">
                <li>
                  <a
                    id="menu-exames"
                    class="site-menu__dropdown-item"
                    href="/exames"
                  >
                    Guia de Exames e Orientações para envio de amostras
                  </a>
                </li>
                <li>
                  <a
                    id="menu-orientacoes-envio-amostras"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/novo-laudo"
                  >
                    Novo Laudo
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          id="site-menu4"
          class="site-menu__collapse"
        >
          <ul class="site-menu__navbar-nav">
            <li class="site-menu__dropdown">
              <div class="site-menu__nav-link">
                Serviços
                <svg-loader src="../../../../static/images/site/arrow-down.svg" />
              </div>
              <ul class="site-menu__dropdown-menu">
                <li>
                  <a
                    id="site-menu4-central-compras"
                    class="site-menu__dropdown-item"
                    href="https://aol.alvaroapoio.com.br"
                  >
                    Central de compras AOL 2.0
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu4-integracoes"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/integracoes"
                  >
                    Integrações
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu4-assessoria-cientifica"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/assessoria-cientifica"
                  >
                    Assessoria Científica UTR e Assessoria Científica de Campo
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          id="site-menu5"
          class="site-menu__collapse"
        >
          <ul class="site-menu__navbar-nav">
            <li class="site-menu__dropdown">
              <div class="site-menu__nav-link">
                Blog
              </div>
            </li>
          </ul>
        </div>
        <div
          id="site-menu6"
          class="site-menu__collapse"
        >
          <ul class="site-menu__navbar-nav">
            <li class="site-menu__dropdown">
              <div class="site-menu__nav-link">
                Fale Conosco
                <svg-loader src="../../../../static/images/site/arrow-down.svg" />
              </div>
              <ul class="site-menu__dropdown-menu">
                <li>
                  <a
                    id="site-menu6-fale-com-alvaro"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/fale-conosco"
                  >
                    Fale com Álvaro Apoio
                  </a>
                </li>
                <li>
                  <a
                    id="site-menu6-envie-mensagem"
                    class="site-menu__dropdown-item"
                    href="https://alvaroapoio.com.br/fale-conosco/contato"
                  >
                    Envie uma mensagem
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteMenu',
  data: () => ({})
}
</script>

<style lang="scss">
.site-menu {
  width: 100%;
  background-color: #fff;

  &__container {
    width: 100%;
    max-width: 1144px;
    margin: 0 auto;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__collapse {
    height: 70px;
    padding: 0 20px;
    display: flex;
    align-items: center;

    &--active {
      position: relative;
      overflow: hidden;

      &:hover {
        overflow: inherit;
      }

      &:before {
        content: '';
        position: absolute;
        width: 16px;
        height: 16px;
        background: #edb5d7;
        left: calc(50% - 8px);
        bottom: -8px;
        border-radius: 50%;
      }
    }

    &:last-child {
      padding-right: 0;
    }

    &:hover {
      background-color: #f2f2f2;
      cursor: pointer;

      .site-menu__dropdown-menu {
        display: flex !important;
      }
    }
  }

  &__nav-link {
    font-family: 'Exo 2', sans-serif;

    &:hover {
      text-decoration: none !important;
      color: inherit !important;
    }

    .md-icon {
      width: 12px;
      height: 12px;
      min-width: 12px;
      min-height: 12px;
      color: #7f1955;
      margin-left: 4px;
    }
  }

  &__dropdown {
    position: relative;
  }

  &__dropdown-item {
    text-decoration: none !important;
  }

  &__dropdown-menu {
    display: none;
    position: absolute;
    z-index: 1000;
    top: 45px;
    left: -30px;
    border-radius: 8px;
    background: #fff;
    padding: 16px 14px;
    color: #383838;
    flex-direction: column;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);

    li {
      padding: 4px 0;

      a {
        white-space: nowrap;
      }
    }

    &--active {
      display: flex;
    }
  }

  &__navbar {
    display: flex;
    justify-content: space-between;
  }
}
</style>
